import React from "react";
import { ListItem, ListItemText, Box, useTheme } from "@mui/material";
import { Link, useMatch } from "react-router-dom";

const MenuItem = ({ label, to, onClick }) => {
  const theme = useTheme();

  // Blog route should be active for /blog and all child routes (e.g. /blog/:slug).
  // All other routes use exact matching so "/" doesn't light up on every page.
  const isBlogRoute = to === "/blog";
  const match = useMatch({ path: to, end: !isBlogRoute });
  const isActive = Boolean(match);

  return (
    <ListItem
      component={Link}
      to={to}
      onClick={onClick}
      sx={{
        borderLeft: isActive
          ? `2px solid ${theme.palette.primary.main}`
          : "2px solid transparent",
        backgroundColor: isActive
          ? `${theme.palette.primary.main}14` // ~8% opacity tint
          : "transparent",
        transition: "background-color 0.15s ease, border-color 0.15s ease",
        "&:hover": {
          backgroundColor: isActive
            ? `${theme.palette.primary.main}1f` // slightly stronger on hover when active
            : `${theme.palette.text.primary}0d`, // subtle hover for inactive items
        },
      }}
    >
      <ListItemText
        primary={
          <>
            <Box
              component="span"
              sx={{ color: isActive ? theme.palette.primary.main : "inherit" }}
            >
              {label}
            </Box>
            <Box component="span" sx={{ color: theme.palette.secondary.main }}>
              ()
            </Box>
          </>
        }
        primaryTypographyProps={{ color: "inherit" }}
      />
    </ListItem>
  );
};

export default MenuItem;
